<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

import {
  ASSET_MUTATION_UPDATE,
  GET_MUTATION_ASSET,
} from '@/services/api/setting/personalization/uiAsset'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Manajemen Whitelabel',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  apollo: {
    uiAsset: {
      query: GET_MUTATION_ASSET,
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.initData(data.uiAssets.uiAssets)
          this.switchCopyright = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'copyrightLogo' && o.module === 'general'
          ).isActive
          this.visible = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'copyrightLogo' && o.module === 'general'
          ).isActive
        }
      },
    },
  },
  data() {
    return {
      companyId: this.getCompanyId(),
      imgPreview: require(`@/assets/images/default-image-user.png`),
      imgPrimaryMax: require(`@/assets/images/default-image-user.png`),
      imgPrimaryMin: require(`@/assets/images/default-image-user.png`),
      imgCopyright: require(`@/assets/images/default-image-user.png`),
      imgFavicon: require(`@/assets/images/default-image-user.png`),
      imgAnimation: require(`@/assets/images/default-image-user.png`),
      primaryMaxName: null,
      primaryMinName: null,
      copyrightName: null,
      faviconName: null,
      tabTitle: null,
      animationName: null,
      switchCopyright: false,
      visible: false,
      carouselData: [
        {
          key: 'exPrimaryLogoMax',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/logo/primary/max/1.png`),
              caption: 'Halaman Login',
            },
            {
              id: 2,
              image: require(`@/assets/images/example/whitelabel/logo/primary/max/2.png`),
              caption: 'Halaman Atur Ulang Kata Sandi',
            },
            {
              id: 3,
              image: require(`@/assets/images/example/whitelabel/logo/primary/max/3.png`),
              caption: 'Sidebar Maximal',
            },
            {
              id: 4,
              image: require(`@/assets/images/example/whitelabel/logo/primary/max/4.png`),
              caption: 'Halaman Login Mobile',
            },
            {
              id: 5,
              image: require(`@/assets/images/example/whitelabel/logo/primary/max/5.png`),
              caption: 'Splash Screen Mobile',
            },
          ],
        },
        {
          key: 'exPrimaryLogoMin',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/logo/primary/min/1.png`),
              caption: 'Sidebar Minimal',
            },
            {
              id: 2,
              image: require(`@/assets/images/example/whitelabel/logo/primary/min/2.png`),
              caption: 'Halaman Utama Mobile',
            },
          ],
        },
        {
          key: 'exCopyrightLogo',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/logo/copyright/1.png`),
              caption: 'Halaman Login',
            },
            {
              id: 2,
              image: require(`@/assets/images/example/whitelabel/logo/copyright/2.png`),
              caption: 'Halaman Profile Mobile',
            },
            {
              id: 3,
              image: require(`@/assets/images/example/whitelabel/logo/copyright/3.png`),
              caption: 'Splash Screen Mobile',
            },
          ],
        },
        {
          key: 'exFavicon',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/logo/favicon/1.png`),
              caption: 'Favicon',
            },
          ],
        },
        {
          key: 'exAnimationLogo',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/logo/loading-animation/1.png`),
              caption: 'Loading Animation Mobile',
            },
          ],
        },
      ],
      carouselItems: null,
      assets: {
        assets: {
          data: [],
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('setting.list.managementAsset.logo.title')
    },
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.homePage.whitelabel'),
          to: { name: 'Management Whitelabel' },
        },
        {
          text: this.$t('setting.list.managementAsset.logo.title'),
          active: true,
        },
      ]
    },
  },

  methods: {
    onExample(id_logo) {
      const ex_logo = id_logo
      const carousel_data = this.$data.carouselData
      for (const element of carousel_data) {
        if (element.key == ex_logo) {
          this.carouselItems = element.items
        }
      }
      this.$bvModal.show('modalExample')
    },
    closeExample() {
      this.carouselItems = null
      this.$bvModal.hide('modalExample')
      this.$bvModal.hide('modalPreviewImage')
    },
    handleFileSelected(e) {
      const indexField = e.target.id
      const file = e.target.files[0]
      let extension_file = ['image/jpg', 'image/jpeg', 'image/png']
      if (indexField == 'animationLogo') {
        extension_file = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif']
      }

      if (file) {
        if (file.size >= 2048000) {
          e.target.value = null
          return this.$mcToast.error(this.$t('global.errorLimitImage'))
        }
        if (!extension_file.includes(file.type)) {
          e.target.value = null
          return this.$mcToast.error(this.$t('global.errorFormatImage'))
        }
        this.toSave(indexField, file)
      }
    },
    async toSave(indexField, file) {
      let assetType = null
      let module = null
      let valChecked = true
      const valueIndexing = [
        {
          key: 'logoPrimaryMax',
          assetType: 'primaryLogo',
          module: 'login',
          valChecked: true,
        },
        {
          key: 'logoPrimaryMin',
          assetType: 'secondaryLogo',
          module: 'sidebarMinimize',
          valChecked: true,
        },
        {
          key: 'logoCopyright',
          assetType: 'copyrightLogo',
          module: 'general',
          valChecked: this.switchCopyright,
        },
        {
          key: 'logoFavicon',
          assetType: 'favicon',
          module: 'general',
          valChecked: true,
        },
        {
          key: 'animationLogo',
          assetType: 'loadingAnimation',
          module: 'mobile',
          valChecked: true,
        },
      ]
      for (const element of valueIndexing) {
        if (element.key == indexField) {
          assetType = element.assetType
          module = element.module
          valChecked = element.valChecked
        }
      }

      const input = {
        assetType: assetType,
        module: module,
        data: {
          value: null,
          isActive: valChecked,
          isPhoto: true,
          photoExt: null,
        },
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.data.value = (await toBase64(file)).split(',')[1]
      input.data.photoExt = file.type.split('/')[1]

      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }

          if (indexField == 'logoPrimaryMax') {
            this.imgPrimaryMax = response.data.updateUIAssets.updateUIAssets[0].value
            this.primaryMaxName = response.data.updateUIAssets.updateUIAssets[0].fileName
          }
          if (indexField == 'logoPrimaryMin') {
            this.imgPrimaryMin = response.data.updateUIAssets.updateUIAssets[0].value
            this.primaryMinName = response.data.updateUIAssets.updateUIAssets[0].fileName
          }
          if (indexField == 'logoCopyright') {
            this.imgCopyright = response.data.updateUIAssets.updateUIAssets[0].value
            this.copyrightName = response.data.updateUIAssets.updateUIAssets[0].fileName
          }
          if (indexField == 'logoFavicon') {
            this.imgFavicon = response.data.updateUIAssets.updateUIAssets[0].value
            this.faviconName = response.data.updateUIAssets.updateUIAssets[0].fileName
          }
          if (indexField == 'animationLogo') {
            this.imgAnimation = response.data.updateUIAssets.updateUIAssets[0].value
            this.animationName = response.data.updateUIAssets.updateUIAssets[0].fileName
          }
          this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
    changeTabTitle() {
      if (this.tabTitle.length > 15) {
        return this.$mcToast.error(this.$t('setting.list.managementAsset.logo.errorTabTitle'))
      }
      if (this.tabTitle !== null) {
        const input = {
          assetType: 'tabTitle',
          module: 'general',
          data: {
            value: this.tabTitle,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        }

        this.$apollo
          .mutate({
            mutation: ASSET_MUTATION_UPDATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.updateUIAssets.message != 'Successful') {
              return this.$mcToast.error(this.$t('global.alert.text.failSave'))
            }
            this.tabTitle = response.data.updateUIAssets.updateUIAssets[0].value
            return this.$mcToast.success(this.$t('global.alert.text.saved'))
          })
      }
    },

    initData(data) {
      const detail = data
      for (const element of detail) {
        if (element.assetType == 'primaryLogo' && element.module == 'login' && !element.isDefault) {
          this.imgPrimaryMax = element.value
          this.primaryMaxName = element.fileName
        } else if (
          element.assetType == 'secondaryLogo' &&
          element.module == 'sidebarMinimize' &&
          !element.isDefault
        ) {
          this.imgPrimaryMin = element.value
          this.primaryMinName = element.fileName
        } else if (
          element.assetType == 'copyrightLogo' &&
          element.module == 'general' &&
          !element.isDefault
        ) {
          this.imgCopyright = element.value ? element.value : this.imgPreview
          this.copyrightName = element.fileName
        } else if (
          element.assetType == 'favicon' &&
          element.module == 'general' &&
          !element.isDefault
        ) {
          this.imgFavicon = element.value
          this.faviconName = element.fileName
        } else if (
          element.assetType == 'loadingAnimation' &&
          element.module == 'mobile' &&
          !element.isDefault
        ) {
          this.imgAnimation = element.value
          this.animationName = element.fileName
        }
      }
      this.tabTitle = detail.find((o) => o.assetType === 'tabTitle' && o.module === 'general').value
    },
    previewImage(id_logo) {
      const ex_logo = id_logo
      switch (ex_logo) {
        case 'exPrimaryLogoMax':
          this.imgPreview = this.imgPrimaryMax
          break
        case 'exPrimaryLogoMin':
          this.imgPreview = this.imgPrimaryMin
          break
        case 'exCopyrightLogo':
          this.imgPreview = this.imgCopyright
          break
        case 'exFavicon':
          this.imgPreview = this.imgFavicon
          break
        case 'exAnimationLogo':
          this.imgPreview = this.imgAnimation
          break
        default:
          this.imagePreview = this.imgPreview
          break
      }
      this.$bvModal.show('modalPreviewImage')
    },
    onSwitchCopyright() {
      if (this.imgCopyright.includes('data:image')) {
        this.imgCopyright = null
      }
      const input = {
        assetType: 'copyrightLogo',
        module: 'general',
        data: {
          value: this.imgCopyright,
          isActive: this.switchCopyright,
          isPhoto: false,
          photoExt: null,
        },
      }

      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }
          this.imgCopyright = response.data.updateUIAssets.updateUIAssets[0].value
            ? response.data.updateUIAssets.updateUIAssets[0].value
            : this.imgPreview
          this.copyrightName = response.data.updateUIAssets.updateUIAssets[0].fileName
          return this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">{{ $t('setting.list.managementAsset.logo.subtitle') }}</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Management Whitelabel' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="mc-form">
      <h4 class="card-title">{{ $t('setting.list.managementAsset.logo.primaryLogo') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="6">
            <h5 class="font-size-14 teal-200 mb-1">
              {{ $t('setting.list.managementAsset.logo.primaryLogoMax') }}
            </h5>
            <b-row>
              <b-col md="3">
                <div
                  class="d-flex justify-content-center mb-2 img-pointer img-pointer"
                  @click="previewImage('exPrimaryLogoMax')"
                >
                  <img
                    :src="imgPrimaryMax"
                    alt
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <h5 class="font-size-12 teal-400 mb-1">
                  {{ primaryMaxName }}
                </h5>
              </b-col>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    id="fleet_brand_type_label"
                    :label="$t('global.uploadImage')"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control inputf-ile"
                      type="file"
                      ref="file"
                      id="logoPrimaryMax"
                      accept="image/*"
                      v-on:change="handleFileSelected"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <a href="javascript:void(0)" @click="onExample('exPrimaryLogoMax')">
                  <strong class="font-weight-bold text-primary">
                    {{ $t('global.exampleAsset') }}
                  </strong>
                </a>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" md="6">
            <h5 class="font-size-14 teal-200 mb-1">
              {{ $t('setting.list.managementAsset.logo.primaryLogoMin') }}
            </h5>
            <b-row>
              <b-col md="3">
                <div
                  class="d-flex justify-content-center mb-2 img-pointer"
                  @click="previewImage('exPrimaryLogoMin')"
                >
                  <img
                    :src="imgPrimaryMin"
                    alt
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <h5 class="font-size-12 teal-400 mb-1">
                  {{ primaryMinName }}
                </h5>
              </b-col>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    id="fleet_brand_type_label"
                    :label="$t('global.uploadImage')"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control inputf-ile"
                      type="file"
                      ref="file"
                      id="logoPrimaryMin"
                      accept="image/*"
                      v-on:change="handleFileSelected"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <a href="javascript:void(0)" @click="onExample('exPrimaryLogoMin')">
                  <strong class="font-weight-bold text-primary">
                    {{ $t('global.exampleAsset') }}
                  </strong>
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="mc-form mb-3">
      <div class="form-check-right form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          id="SwitchCheckSizemd"
          v-b-toggle.accordion-copyright
          v-model="switchCopyright"
          v-on:change="onSwitchCopyright"
        />
      </div>
      <span class="card-title p-2">{{
        $t('setting.list.managementAsset.logo.copyrightLogo')
      }}</span>
      <b-collapse
        id="accordion-copyright"
        accordion="my-accordion"
        role="tabpanel"
        v-model="visible"
      >
        <b-card>
          <b-row>
            <b-col sm="12" md="6">
              <b-row>
                <b-col md="3">
                  <div
                    class="d-flex justify-content-center mb-2 img-pointer"
                    @click="previewImage('exCopyrightLogo')"
                  >
                    <img
                      :src="imgCopyright"
                      alt
                      class="avatar-lg rounded-circle img-thumbnail"
                      style="object-fit: cover"
                    />
                  </div>
                </b-col>
                <b-col md="12">
                  <h5 class="font-size-12 teal-400 mb-1">
                    {{ copyrightName }}
                  </h5>
                </b-col>
                <b-col md="12">
                  <div class="mc-input-info">
                    <b-form-group
                      id="fleet_brand_type_label"
                      :label="$t('global.uploadImage')"
                      label-for="fleet_brand_type"
                    >
                      <input
                        class="form-control inputf-ile"
                        type="file"
                        ref="file"
                        id="logoCopyright"
                        accept="image/*"
                        v-on:change="handleFileSelected"
                      />
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12" class="mt-3">
              <a href="javascript:void(0)" @click="onExample('exCopyrightLogo')">
                <strong class="font-weight-bold text-primary">
                  {{ $t('global.exampleAsset') }}
                </strong>
              </a>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>
    </div>

    <div class="mc-form">
      <h4 class="card-title">{{ $t('setting.list.managementAsset.logo.faviconLogo') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="12">
            <b-row>
              <b-col md="12">
                <div
                  class="d-flex justify-content-right mb-2 img-pointer"
                  @click="previewImage('exFavicon')"
                >
                  <img
                    :src="imgFavicon"
                    alt
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <h5 class="font-size-12 teal-400 mb-1">
                  {{ faviconName }}
                </h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    id="fleet_brand_type_label"
                    label="Unggah Gambar"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control inputf-ile"
                      type="file"
                      ref="file"
                      id="logoFavicon"
                      accept="image/*"
                      v-on:change="handleFileSelected"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <a href="javascript:void(0)" @click="onExample('exFavicon')">
                  <strong class="font-weight-bold text-primary">
                    {{ $t('global.exampleAsset') }}
                  </strong>
                </a>
              </b-col></b-row
            >
          </b-col>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    :label="$t('setting.list.managementAsset.logo.tabTitle')"
                    id="fleet_brand_type_label"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control"
                      type="text"
                      id="tabTitle"
                      accept="image/*"
                      :placeholder="$t('setting.list.managementAsset.logo.exTabTitle')"
                      v-model="tabTitle"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <b-button @click="changeTabTitle()" variant="primary">
                  <i class="mc-fa icon-fill_checkmark"></i>
                  {{ $t('global.apply') }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="mc-form">
      <h4 class="card-title">{{ $t('setting.list.managementAsset.logo.loadingAnimation') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="3">
                <div
                  class="d-flex justify-content-center mb-2 img-pointer"
                  @click="previewImage('exAnimationLogo')"
                >
                  <img
                    :src="imgAnimation"
                    alt
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <h5 class="font-size-12 teal-400 mb-1">
                  {{ animationName }}
                </h5>
              </b-col>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    id="fleet_brand_type_label"
                    :label="$t('global.uploadImage')"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control inputf-ile"
                      type="file"
                      ref="file"
                      id="animationLogo"
                      accept="image/*"
                      v-on:change="handleFileSelected"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <a href="javascript:void(0)" @click="onExample('exAnimationLogo')">
                  <strong class="font-weight-bold text-primary">
                    {{ $t('global.exampleAsset') }}
                  </strong>
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <b-modal
      id="modalExample"
      size="xl"
      centered
      hide-header
      hide-footer
      modal-class="mc-modal-asset"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="mc-modal-asset__wrapper">
        <i class="mc-fa icon-outline_close" @click="closeExample()"></i>
        <b-carousel id="carousel-1" controls no-animation>
          <b-carousel-slide
            v-for="item in carouselItems"
            :key="item.id"
            :caption="item.caption"
            :interval="0"
          >
            <template #img>
              <img
                :src="item.image"
                :style="{ height: item.caption == 'Favicon' ? '200px' : '450px' }"
                alt
              />
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal
      id="modalPreviewImage"
      size="xl"
      centered
      hide-header
      hide-footer
      modal-class="mc-modal-asset"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="mc-modal-preview__wrapper">
        <i class="mc-fa icon-outline_close" @click="closeExample()"></i>
        <img :src="imgPreview" alt="image preview" />
      </div>
    </b-modal>
  </Layout>
</template>
